var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLaunch = function SvgLaunch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.083 22.91h21.883M3.578 19.525c.114.112 1.137-.296 2.868-2.607M7.366 19.474c.115.113 1.137-.295 2.868-2.607M15.647 11.552l5.08-7.165c.305-.651.484-4.847-4.355 1.66-2.998 1.238-5.588 1.042-8.31 1.309l-.843 1.8 6.173.77c-2.809 3.926-3.979 3.598-5.952 3.35L6.437 14.88c2.804-.372 4.727 1.635 9.21-3.33z"
  })));
};
export default SvgLaunch;